module.exports = __webpack_public_path__ + "media/warranty-claim/photos-wide-angle-cef56570.png";